const PhotoPrice = {
	// Captures charges $29.99 for the first 50, and $0.50 per photo after the first 50 per type of photos (there are three types: Photos, Slides, Negatives)
	rule: function (price, photoQuantityArr, isSale) {
		const upsellTotal =
			Number($(".product-price").attr("data-upsell-dvd-total-price")) +
			Number($(".product-price").attr("data-upsell-usb-total-price"));

    var extraItemPrice = Number($(".product-price").attr("data-extra-price"));
    var extraSlidePrice = Number($(".product-price").attr("data-extra-slide-price"));
    var extraNegativePrice = Number($(".product-price").attr("data-extra-negative-price"));
    const includedQuantity = Number($(".product-price").attr("data-included-quantity"));
		var extraCharge = extraItemPrice;

		var newPrice = 0;

		for (var key in photoQuantityArr) {
      // based on key, figure out which extra price to use for photo product.
      // not necessary for aother transfers
      if (key == "Prints") {
        extraCharge = extraItemPrice;
      } else if (key == "Slides") {
        extraCharge = extraSlidePrice;
      } else if (key == "Negatives") {
        extraCharge = extraNegativePrice;
      }

			var photoQuantity = photoQuantityArr[key];
      var extraQuantity = photoQuantity - includedQuantity;

      newPrice += price;

      if (extraQuantity > 0) {
        // add any extra quantity
        newPrice += extraCharge * extraQuantity;
      }

		}

		newPrice += upsellTotal;
		newPrice = Math.max(newPrice, price);
		return [newPrice, formatMoney(newPrice)];
	},
	variants: function (callback) {
		var photoQuantityInputs = $('input[name="photo-quantity"]');
		var submitButton = $("button.product-form__submit");

		photoQuantityInputs.change(function (e) {
			var value = Number($(this).val());
			var errorMessageWrapper = $(
				".product-photo__error-message-wrapper"
			);
			if (value > CONSTANTS.PHOTO.MAX_INPUT) {
				$(this).val(CONSTANTS.PHOTO.MAX_INPUT);
				errorMessageWrapper.removeAttr("hidden");
				errorMessageWrapper
					.find(".product-photo__error-message")
					.text(
						`Maximum quantity for photo input is ${CONSTANTS.PHOTO.MAX_INPUT}`
					);
			} else {
				errorMessageWrapper.attr("hidden", true);
			}

			var photoQuantity = 0;
			var photoTotalQuantityArr = [];
			// Update total number of film feet
			photoQuantityInputs.each(function (i, e) {
				var value = Number($(this).val());
				var typeValue = $(this).attr("data-photo-type");
				if (value) {
					photoQuantity += value;
					photoTotalQuantityArr[typeValue] = value;
				}
			});

			if (photoQuantity > 0) {
				if (submitButton.prop("disabled")) {
					submitButton.prop("disabled", false);
				}
			} else {
				submitButton.prop("disabled", true);
			}
			// Callback
			if (callback) {
				callback(photoTotalQuantityArr);
			}
		});
	},

  dynamicPrice: function() {

    const extraItemPrice          = Number($(".product-price").attr("data-extra-price"));
    const extraItemCompareAtPrice = Number($(".product-price").attr("data-extra-compare-at-price"));
    const includedQuantity        = Number($(".product-price").attr("data-included-quantity"));
  	const productPrice            = Number($(".product-price").attr("data-price"));
    const productCompareAtPrice   = Number($(".product-price").attr("data-compare-price"));

    if (extraItemPrice) {
      $(".unit-item-extra-item-price").text( formatMoney(extraItemPrice) );
    }

    if (extraItemCompareAtPrice) {
      $(".unit-item-extra-item-compare-at-price").text( formatMoney(extraItemCompareAtPrice) );
    }

    if (productPrice) {
      $(".unit-item-price").text( formatMoney(productPrice) );
    }

    if (productCompareAtPrice) {
      $(".unit-item-compare-at-price").text( formatMoney(productCompareAtPrice) );
    }

    if (includedQuantity) {
      $(".unit-item-included-quantity").text( includedQuantity );
    }
  },

};

document.addEventListener("DOMContentLoaded", () => {
	const priceRegularWrapper = $(".product-price .price-item--regular");
	const priceSaleWrapper = $(".product-price .price-item--sale");
	const originalPrice = Number(
		$(".product-price").attr("data-compare-price")
	);
	const originalSalePrice = Number($(".product-price").attr("data-price"));

  PhotoPrice.dynamicPrice();

	PhotoPrice.variants((photoTotalQuantityArr) => {
		const [newPriceRegular, newPriceRegularFormatted] = PhotoPrice.rule(
			originalPrice,
			photoTotalQuantityArr
		);
		const [newPriceSale, newPriceSaleFormatted] = PhotoPrice.rule(
			originalSalePrice,
			photoTotalQuantityArr,
			true
		);
		priceRegularWrapper.text(newPriceRegularFormatted);
		priceSaleWrapper.text(newPriceSaleFormatted);
		$(".product-price").attr("data-total-price", newPriceSale);
		$(".product-price").attr("data-total-compare-price", newPriceRegular);
	});
});